<template>
  <div>
    <loading v-if="loading"></loading>
    <div class="m-container" v-else>
      <h1 class="about-header">Participation Space</h1>
      <!-- <i class="fas fa-thumbs-up"></i> -->
      <div class="mb-20">
        <div class="row justify-start">
          <div class="card mb-2" v-for="(video, index) in data" :key="index" style="margin:10px 3px">
            <div style="border: 1px gray solid">
              <iframe style="width:100%" :src="video.url" frameborder="0" allowfullscreen></iframe>
              <div class="row justify-between" style="padding:5px">
                <a href="javascript:;" @click="likeUnlikeVideo(video.id)">
                  <img v-if="likedVideos.includes(video.id)" height="16" width="16" src="@/assets/img/liked.png"
                    alt="" />
                  <img v-else height="16" width="16" src="@/assets/img/like.png" alt="" />
                </a>
                <div class="font-bold">
                  Likes: {{video.all_likes}}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-if="pagination.total >= 16" class="text-center the-button">
          <button class="wro-button secondaryButtons" @click="() => fetchVideos(myIP, pagination.current_page - 1)" :disabled="pagination.current_page == 1"><span>Previous</span></button>
          <button class="wro-button secondaryButtons" @click="() => fetchVideos(myIP, pagination.current_page + 1)" :disabled="pagination.current_page == pagination.last_page"><span>Next</span></button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Loading from "@/components/Loading/loading";
import axios from 'axios';
export default {
  name: "ZeroOneSpace",
  components: { Loading },
  data() {
    return {
      data: [],
      likedVideos: [],
      pagination: {},
      myIP: '',
      loading: true,
    }
  },
  methods: {
    likeUnlikeVideo(video_id) {
      this.$API.general.likeUnlikeVideo(video_id, this.myIP)
        .then(response => {
          this.fetchVideos(this.myIP);
          // this.likedVideos = response;
        }).catch(() => {
        })
    },
    fetchVideos(ip, page) {
      this.data = [];
      this.loading = true;
      this.$API.general.videos(ip, page)
        .then(response => {
          this.data = response.videos.data;
          this.pagination = response.videos.pagination;
          this.likedVideos = response.likedVideos;
          this.loading = false
        }).catch(() => {
          this.loading = false
        })
    },
    youtubeParser(url) {
      const regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/;
      const match = url.match(regExp);
      return `https://www.youtube.com/embed/${match[match.length - 1]}`;
    }
  },
  mounted() {
    axios.get('https://api.ipify.org/?format=json').then(response => {
      this.myIP = response.data.ip;
      this.fetchVideos(this.myIP)
    })
    // 
  }
}
</script>

<style scoped>
.wro-button{ width: 205px; height: 60px; border-radius: 30px; box-shadow: none;}
.wro-button span{ font-size: 1.245rem; font-weight: 500;}
.about-header {
  font-size: 20px;
  line-height: 1;
  text-align: center;
}

.page-full-height {
  height: calc(100vh - 290px);
  ;
}

@media (max-width: 467px) {
  .card {
    width: 100%
  }
}
</style>